import { render, staticRenderFns } from "./AllocationUnitCreate.vue?vue&type=template&id=0f961e8a&"
import script from "./AllocationUnitCreate.vue?vue&type=script&lang=js&"
export * from "./AllocationUnitCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports